import React, { useState, useEffect, ReactNode } from "react";
import cx from "classnames";
import { toast } from "sonner";

import { Copy } from "@geist-ui/icons";

import { Typography } from "../typography";
import { Badge } from "@radix-ui/themes";
import { mixTrackEvent, ReportEvents } from "../../assets/mixpanel";

import styles from "./styles.module.scss";

export const useToggle = () => {
  const [isOpen, setOpen] = useState(false);

  const toggle = () => setOpen((prev) => !prev);

  return [isOpen, toggle] as const;
};

export const Header = ({
  name,
  id,
  description,
  isloading,
}: {
  name?: string;
  description?: string;
  id?: string;
  isloading?: boolean;
}) => {
  const [meta, setMeta] = useState({ name, description });
  const [isCopied, setCopied] = useState(false);

  const handleCopyLink = () => {
    navigator?.clipboard?.writeText(`${window.location.origin}/report/${id}`);
    mixTrackEvent({
      event: ReportEvents.PRESS_COPY_LINK_REPORT,
    });
    isCopied && toast("Copied to clipboard");
    setCopied(true);
  };

  useEffect(() => {
    setMeta({ name, description });
  }, [name, description]);

  return (
    <>
      <div className={styles.container}>
        <span className={styles["g-16"]}>
          <div className="flex flex-col gap-2">
            <>
              {name && (
                <Typography type="page_headline" theme="secondary">
                  {meta.name}
                </Typography>
              )}
              {description && (
                <Typography type="tab" theme="secondary">
                  {meta.description}
                </Typography>
              )}
            </>
          </div>
        </span>
        <span>
          <Badge
            color={isloading ? "gray" : !isCopied ? "blue" : "green"}
            onClick={handleCopyLink}
            style={{ cursor: "pointer" }}
          >
            <Copy />
            Copy Report Link{" "}
          </Badge>
        </span>
      </div>
    </>
  );
};

export const SimpleButton = ({
  children,
  ...props
}: { children: ReactNode } & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>) => {
  return (
    <button {...props} className={cx(styles.button, props.className)}>
      {children}
    </button>
  );
};
